import React, { useState, useEffect, useRef } from "react";
import { _Api,_PdfApi } from "../api/_call";
import EditColumnSubmenu from "../common/modules/EditColumnSubmenu";
import { Tablehead } from "../common/modules/Tablehead";
import { error, loading, Updateloading } from "../common/helpers/toastify";
import { NewPaginationBlock } from "./NewPaginationBlock";
import { SetdataTable, UnSetdataTable } from "../api/setdatatable";
import { NewDateRange } from "./NewDateRange";
import DatePicker from "react-datepicker";
import SocialModal from "../common/modules/SocialModal/SocialModal";
import Select from "react-select";
import {
  MultiLocationList,
  SupplierList,
  VoucherList,
} from "../common/graphql/commonlayouts";
import { inventorylowstockplanlisthead } from "../common/Tablehead";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "./LowStockPlanning.scss";
import NewSocialModal from "../StockTake/NewSocialModal";
import IconReplenishment from "../../assets/icons/IconReplenishment-Gr.svg";

import { Link } from "react-router-dom";
const LowStockPlanning = (props) => {
  const { t } = useTranslation();
  const datePickerRef = useRef(null);
  const [limit, setLimit] = useState(100);
  const [startdate, setStartdate] = useState();
  const [enddate, setEnddate] = useState();
  const [multisetcommanSelected_loc, setMultisetcommanSelected_loc] =
    useState();
  const [datelable, setDatelable] = useState("Replenish");
  const [commanSelected_sup, setcommanSelected_sup] = useState("");
  const [commanSelected_vouc, setcommanSelected_vouc] = useState([]);
  const [datefilter, setDatefilter] = useState([]);
  const [filtername, setFiltername] = useState("");
  const [lowstocklist, setLowstocklist] = useState([]);
  const [newcolumndata, setnewcolumndata] = useState(
    inventorylowstockplanlisthead
  );
  const [shareloader, setShareloader] = useState(false);
  const [isRunning, setIsRunning] = useState(false);
  const [socialurl, setSocialurl] = useState();
  const [lowstockcounts, setLowstockcounts] = useState([]);
  const [, setfilterby] = useState("");
  const [SelectAllStatus, setSelectAllStatus] = useState();
  const base_url_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  let Permission = parmissiondatashow?.Low_Stock_Planning;
  const [selecteditem, setSelecteditem] = useState([]);
  const [isInputVisible, setIsInputVisible] = useState(false);
  const inputRef = useRef(null);
  const closeEditColumns = useRef(null);
  const secondRowOption = useRef(null);
  const closeActionsLSPTable = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [showEditColumns, setShowEditColumns] = useState(false);
  const [showActionMenu, setShowActionMenu] = useState(null);



  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // const closeDropdown = () => {
  //   setIsOpen(false);
  // };

  const handleClickOutside = (event) => {
    if (inputRef.current && !inputRef.current.contains(event.target)) {
      setIsInputVisible(false);
    }

    if (closeEditColumns.current && !closeEditColumns.current.contains(event.target)) {
      setShowEditColumns(false);
    }

    if (secondRowOption.current && !secondRowOption.current.contains(event.target)) {
      setIsOpen(false);
    }

    if (closeActionsLSPTable.current && !closeActionsLSPTable.current.contains(event.target)) {
      setShowActionMenu(false);
    }


  };
  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    callcolumns();
  }, []);
    const handleOpenPDF = async (id) => {
      let GetloadingID = loading();
      try {
        const blobData = await _PdfApi({ id }, 'api/v1/inventory/my/generatelowstockPdf');
        const blob = new Blob([blobData], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
        Updateloading(t, GetloadingID, t("Pdf is opened at another tab"));
      } catch (err) {
        // console.error("Error opening PDF:", err);
        // error(t("Something Went Wrong!!"));
        Updateloading(t, GetloadingID, t("somthing went wrong"), 'error');
      }
    };
  const callcolumns = async () => {
    try {
      const postdata = {
        name: "Low_stock_planning_tbl",
      };
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`
      );
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getlowstockplanning = async (firstlimit) => {
    if (isRunning) return;
    let locationarray = [];
    if (multisetcommanSelected_loc?.length) {
      multisetcommanSelected_loc.forEach((result) => {
        locationarray.push(result?.value);
      });
    }
    try {
      if (!commanSelected_vouc) {
        error(t("Please select voucher"));
        return;
      }
      if (!commanSelected_sup) {
        error(t("Please select Supplier"));
        return;
      }
      setIsRunning(true);
      let GetloadingID = loading();
      const postdata = {
        location: locationarray,
        supplier: commanSelected_sup,
        skip: "0",
        limit: firstlimit ? firstlimit : limit,
        start_date: startdate ? startdate : new Date(),
        end_date: enddate ? enddate : new Date(),
        voucher_id: commanSelected_vouc,
      };
      let reslowstock = await _Api(
        postdata,
        `api/v1/inventory/my/lowstockCreate`
      );
      if (reslowstock.code === 200) {
        setTimeout(() => {
          Updateloading(t, GetloadingID, t("Successfully Run"));
          // setcommanSelected_sup([]);
          // setMultisetcommanSelected_loc([]);
          setDatelable("Replenish");
          getlowstocklist();
        });
      } else {
        Updateloading(t, GetloadingID, reslowstock?.errors, "error");
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setIsRunning(false);
    }
  };
  const changeDates = (lable) => {
    const MainDate = new Date();
    if (lable === "Today") {
      setStartdate(new Date());
      setEnddate(new Date());
      setDatelable("Today");
    } else if (lable === "Yesterday") {
      const yesterdaydate = new Date(MainDate.setDate(MainDate.getDate() - 1));
      setStartdate(yesterdaydate);
      setEnddate(yesterdaydate);
      setDatelable("Yesterday");
    } else if (lable === "7days") {
      const sevendays = new Date(MainDate.setDate(MainDate.getDate() - 7));
      setStartdate(sevendays);
      setEnddate(new Date());
      setDatelable("7days");
    } else if (lable === "30days") {
      const days = new Date(MainDate.setDate(MainDate.getDate() - 30));
      setStartdate(days);
      setEnddate(new Date());
      setDatelable("30days");
    } else if (lable === "ThisMonth") {
      const firstDay = new Date(MainDate.getFullYear(), MainDate.getMonth(), 1);
      const lastDay = new Date(
        MainDate.getFullYear(),
        MainDate.getMonth() + 1,
        0
      );
      setStartdate(firstDay);
      setEnddate(lastDay);
      setDatelable("ThisMonth");
    } else if (lable === "LastMonth") {
      const firstDay = new Date(
        MainDate.getFullYear(),
        MainDate.getMonth() - 1,
        1
      );
      const lastDay = new Date(MainDate.getFullYear(), MainDate.getMonth(), 0);
      setStartdate(firstDay);
      setEnddate(lastDay);
      setDatelable("LastMonth");
    }
  };
  const grtprintlowstock = async () => {
    let GetloadingID = loading();
    try {
      const postdata = {
        search: filtername,
        start_date: datefilter ? datefilter[0] : "",
        end_date: datefilter ? datefilter[1] : "",
      };
      let res = await _Api(postdata, `api/v1/Inventory/reports/print/lowstock`);
      if (res.code === 200) {
        setTimeout(() => {
          const exportLinkElement = document.createElement("a");
          exportLinkElement.hidden = true;
          exportLinkElement.download = res?.name ? res?.name : "report.pdf";
          exportLinkElement.href = res?.link;
          exportLinkElement.text = "downloading...";
          exportLinkElement.setAttribute("target", "_blank");
          document.body.appendChild(exportLinkElement);
          exportLinkElement.click();
          exportLinkElement.remove();
          Updateloading(t, GetloadingID, t("download successfully"));
        }, 50);
        setSocialurl(res?.link);
      } else {
        Updateloading(
          t,
          GetloadingID,
          res?.message ? res?.message : res?.errors,
          "error"
        );
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, err, t("error"));
    }
  };

  const filterbyname = (search) => {
    getlowstocklist(currentPage, limit, search);
    setstate({ ...state, currentPage: 1 });
  };
  const getlimit = (limit) => {
    setLimit(limit);
    getlowstocklist(1, limit);
    setstate({ ...state, currentPage: 1 });
  };
  const [state, setstate] = useState({
    totalPages: 20,
    currentPage: 1,
  });
  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 },
  ];
  const { totalPages, currentPage } = state;
  const handlePaginations = (current) => {
    setstate({ ...state, currentPage: current });
    getlowstocklist(current, "");
  };
  const getlowstocklist = async (current, firstlimit, search) => {
    UnSetdataTable("low_stock_table");
    try {
      const postdata = {
        search: search ? search : "",
        skip: current ? (current - 1) * limit : 0,
        limit: firstlimit ? firstlimit : limit,
        start_date: datefilter ? datefilter[0] : "",
        end_date: datefilter ? datefilter[1] : "",
      };
      let res = await _Api(postdata, `api/v1/inventory/my/lowstocklist`);
      if (res?.code === 200) {
        setLowstocklist(res?.data);
        setTimeout(() => {
          SetdataTable("low_stock_table", 4, newcolumndata, [0]);
          setstate({
            ...state,
            totalPages: Math.ceil(res?.total / postdata.limit),
            currentPage: current ? current : 1,
          });
        }, 50);
        setLowstockcounts(res?.count);
      } else {
        SetdataTable("low_stock_table", 4, newcolumndata, [0]);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const getsharelowstock = async () => {
    setShareloader(true);
    try {
      const postdata = {
        search: filtername,
        start_date: datefilter ? datefilter[0] : "",
        end_date: datefilter ? datefilter[1] : "",
      };
      let res = await _Api(postdata, `api/v1/Inventory/reports/print/lowstock`);
      if (res.code === 200) {
        setSocialurl(res?.link);
        setShareloader(false);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const downloadFilesXlxsAndPDF = (url) => {
    try {
      console.log(url, "url");
      if (url) {
        window.open(url, '_blank', 'noreferrer')
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    if (datefilter[0] && datefilter[1]) {
      getlowstocklist();
    }
    // eslint-disable-next-line
  }, [datefilter]);
  const downloadexclsheet = async () => {
    let GetloadingID = loading();
    try {
      let postdata = {
        id: selecteditem?.length ? selecteditem : [],
      };
      let res = await _Api(postdata, `api/v1/Inventory/my/lowstock-export`);
      if (res?.code === 200) {
        Updateloading(t, GetloadingID, res?.message);
      } else {
        Updateloading(t, GetloadingID, res?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const selectedproduct = (isChecked, id) => {
    if (isChecked) {
      setSelecteditem((prevSelected) => [...prevSelected, id]);
    } else {
      setSelecteditem((prevSelected) =>
        prevSelected.filter((item) => item !== id)
      );
    }
  };

  useEffect(() => {
    if (SelectAllStatus) {
      if (lowstocklist?.length) {
        // Create a unique set of IDs to avoid duplicates
        setSelecteditem(prevSelected => {
          const prevSet = new Set(prevSelected); // Use Set for uniqueness
          lowstocklist.forEach(result => prevSet.add(result?._id));
          return Array.from(prevSet); // Convert back to an array
        });
      }
    } else {
      setSelecteditem([]); // Clear the selection if `SelectAllStatus` is false
    }
  }, [SelectAllStatus, lowstocklist, setSelecteditem]);
  const [showCreatePoBtn, setShowCreatePoBtn] = useState(false);
  console.log(selecteditem, 'selecteditem>>>>>>');
  useEffect(() => {
    if (selecteditem && lowstocklist?.length > 0) {
      // Step 1: Filter `lowstocklist` items whose `_id` is in `selecteditem`
      const matchingItems = lowstocklist.filter(item =>
        selecteditem.includes(item._id)
      );

      // Step 2: Extract and compare `location_ids` for all matching items
      const locationSets = matchingItems.map(item => item.location_ids.join(","));

      // Step 3: Check if all `location_ids` are the same
      const isMatching =
        locationSets.length > 0 &&
        locationSets.every(loc => loc === locationSets[0]);

      console.log("isMatching:", isMatching);
      setShowCreatePoBtn(isMatching);
    }
  }, [selecteditem, lowstocklist]);

  return (
    <React.Fragment>
      <div className="main-body style-lsp-page-new">
        <div className="row" id="new-brandcumcategory-lsp">
          <div className="main-content-wrapper-body-top-bar d-flex align-items-center justify-content-between">
            <div className="main-content-wrapper-body-top-bar-left">
              <h1 className="main-content-wrapper-body-top-bar-left-heading fw-semibold mb-0">
                {t("Inventory")} <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 5L13 10L8 15" stroke="#A0A0A0" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>{t("Low Stock Planning")}</span>
              </h1>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 main-container">

              <div className="top-heading-area-left">
                <VoucherList
                  setcommanSelected_vouc={setcommanSelected_vouc}
                  group={"Low_Stock_Planning"}
                ></VoucherList>
              </div>

              <div className="main-body-top-inventory">
                <div className="main-body-top-inventory-status">
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M27.1831 9.54337L15.9999 16L4.81226 9.53308"
                          stroke="#7CC7FA"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M16.0001 16.0001V28.0001"
                          stroke="#7CC7FA"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M14.6668 3.43655C15.4919 2.96019 16.5084 2.96019 17.3335 3.43655L26.2139 8.56362C27.0389 9.03998 27.5472 9.92032 27.5472 10.873V21.1272C27.5472 22.0798 27.0389 22.9602 26.2139 23.4366L17.3335 28.5636C16.5084 29.04 15.4919 29.04 14.6668 28.5636L5.78646 23.4366C4.96138 22.9602 4.45312 22.0798 4.45312 21.1272V10.873C4.45312 9.92032 4.96138 9.03998 5.78646 8.56362L14.6668 3.43655Z"
                          stroke="#7CC7FA"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M11.3335 6.00006L21.3335 12.0001"
                          stroke="#7CC7FA"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="right-side">
                      <p className="inventory-name">{t("Total Qty")}</p>
                      <h2 className="inventory-value stock">
                        {lowstockcounts?.totalStock
                          ? lowstockcounts?.totalStock
                          : "0"}
                      </h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <svg
                        width="18"
                        height="28"
                        viewBox="0 0 18 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.333313 18.0367C0.333313 15.364 1.16465 13.1367 2.82732 11.3548C4.48999 9.56273 6.56371 8.66669 9.04847 8.66669C11.4593 8.66669 13.4961 9.57297 15.1588 11.3855C16.8307 13.1981 17.6666 15.4152 17.6666 18.0367C17.6666 20.7095 16.8261 22.9676 15.1449 24.8108C13.4638 26.6541 11.4085 27.5758 8.9792 27.5758C6.55909 27.5758 4.51308 26.6541 2.84117 24.8108C1.16927 22.9676 0.333313 20.7095 0.333313 18.0367ZM2.82732 18.0675C2.82732 20.6993 3.39078 22.8293 4.5177 24.4575C5.64462 26.0755 7.12255 26.8845 8.95149 26.8845C10.7989 26.8845 12.2953 26.0551 13.4407 24.3961C14.5953 22.7371 15.1726 20.6686 15.1726 18.1904C15.1726 15.5278 14.6092 13.3927 13.4823 11.7849C12.3553 10.1669 10.8959 9.35792 9.1039 9.35792C7.20106 9.35792 5.67695 10.1516 4.53155 11.7388C3.3954 13.3261 2.82732 15.4357 2.82732 18.0675Z"
                          fill="#FE918F"
                        />
                        <path
                          d="M8.89337 0L9.91685 7.09091H7.86988L8.89337 0Z"
                          fill="#FE918F"
                        />
                        <path
                          d="M15.6997 1.86112L13.2395 8.24693L10.7784 7.06778L15.6997 1.86112Z"
                          fill="#FE918F"
                        />
                        <path
                          d="M2.08721 1.86112L4.54741 8.24693L7.00851 7.06778L2.08721 1.86112Z"
                          fill="#FE918F"
                        />
                      </svg>
                    </div>
                    <div className="right-side">
                      <p className="inventory-name">{t("Sale Order")}</p>
                      <h2 className="inventory-value danger-text">
                        {lowstockcounts?.totalSalesOrder
                          ? lowstockcounts?.totalSalesOrder
                          : "0"}
                      </h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <svg
                        width="24"
                        height="29"
                        viewBox="0 0 24 29"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 26.8C12 26.8 22.0174 17.8957 22.0174 11.2174C22.0174 5.68495 17.5325 1.20001 12 1.20001C6.46754 1.20001 1.9826 5.68495 1.9826 11.2174C1.9826 17.8957 12 26.8 12 26.8Z"
                          stroke="#5DD0CC"
                          strokeWidth="2"
                        />
                        <path
                          d="M15.2004 10.8002C15.2004 12.5675 13.7677 14.0002 12.0004 14.0002C10.2331 14.0002 8.80041 12.5675 8.80041 10.8002C8.80041 9.0329 10.2331 7.60021 12.0004 7.60021C13.7677 7.60021 15.2004 9.0329 15.2004 10.8002Z"
                          stroke="#5DD0CC"
                          strokeWidth="2"
                        />
                      </svg>
                    </div>
                    <div className="right-side">
                      <p className="inventory-name">{t("Locations")}</p>
                      <h2 className="inventory-value location">
                        {lowstockcounts?.locationcount
                          ? lowstockcounts?.locationcount
                          : "0"}
                      </h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M26.5773 17.388C26.3255 19.3079 25.5559 21.1231 24.3509 22.6389C23.1459 24.1546 21.551 25.3138 19.7373 25.992C17.9236 26.6702 15.9594 26.842 14.0555 26.4887C12.1516 26.1355 10.3798 25.2707 8.93006 23.9871C7.48032 22.7034 6.40735 21.0493 5.82622 19.2022C5.2451 17.3551 5.17775 15.3846 5.6314 13.5021C6.08505 11.6196 7.04258 9.89611 8.40129 8.51645C9.76001 7.1368 11.4687 6.15303 13.344 5.67065C18.5427 4.33731 23.924 7.01331 25.9107 12"
                          stroke="#4F9AF1"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M26.6667 5.33331V12H20"
                          stroke="#4F9AF1"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="right-side">
                      <p className="inventory-name">{t("Reorder Quantity")}</p>
                      <h2 className="inventory-value value">
                        {lowstockcounts?.totalRQ
                          ? lowstockcounts?.totalRQ
                          : "0"}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="main-body-top-status-bar low-stock-bar">
                <div className="common-select left-select">
                  <SupplierList setcommanSelected_sup={setcommanSelected_sup} />
                </div>
                <div className="product-multi-select">
                  <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.00001 17C7.00001 17 13.2609 11.4348 13.2609 7.26087C13.2609 3.80309 10.4578 1 7.00001 1C3.54222 1 0.739136 3.80309 0.739136 7.26087C0.739136 11.4348 7.00001 17 7.00001 17Z" stroke="#A4A4A4" />
                    <path d="M9.00026 7.00013C9.00026 8.1047 8.10483 9.00013 7.00026 9.00013C5.89569 9.00013 5.00026 8.1047 5.00026 7.00013C5.00026 5.89556 5.89569 5.00013 7.00026 5.00013C8.10483 5.00013 9.00026 5.89556 9.00026 7.00013Z" stroke="#A4A4A4" />
                  </svg>


                  <div className="product-multi-select-box ">
                    <MultiLocationList
                      setMultisetcommanSelected_loc={
                        setMultisetcommanSelected_loc
                      }
                    />
                  </div>
                </div>
                <div className="main-body-top-status-bar-multi-date-picker">
                  <div className="main-body-top-status-bar-note-button common-dropdown replenish-date">
                    <button
                      className="dropdown-toggle btn-style align-items-center d-flex"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 4.66667V8L10.5 10.5M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>

                      {datelable}
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li
                        className={`dropdown-item ${datelable === "Today" || datelable === "Replenish"
                          ? "active"
                          : ""
                          }`}
                        onClick={() => changeDates("Today")}
                      >
                        {t("Today")}
                      </li>
                      <li
                        className={`dropdown-item ${datelable === "Yesterday" ? "active" : ""
                          }`}
                        onClick={() => changeDates("Yesterday")}
                      >
                        {t("Yesterday")}
                      </li>
                      <li
                        className={`dropdown-item ${datelable === "7days" ? "active" : ""
                          }`}
                        onClick={() => changeDates("7days")}
                      >
                        {t("Last 7 days")}
                      </li>
                      <li
                        className={`dropdown-item ${datelable === "30days" ? "active" : ""
                          }`}
                        onClick={() => changeDates("30days")}
                      >
                        {t("Last 30 days")}
                      </li>
                      <li
                        className={`dropdown-item ${datelable === "ThisMonth" ? "active" : ""
                          }`}
                        onClick={() => changeDates("ThisMonth")}
                      >
                        {t("This Month")}
                      </li>
                      <li
                        className={`dropdown-item ${datelable === "LastMonth" ? "active" : ""
                          }`}
                        onClick={() => changeDates("LastMonth")}
                      >
                        {t("Last Month")}
                      </li>
                      <li
                        className={`dropdown-item ${datelable === "Custom Range" ? "active" : ""
                          }`}
                        onClick={() => datePickerRef.current.setOpen(true)}
                      >
                        {t("Custom Range")}
                      </li>
                    </ul>
                    <DatePicker
                      selectsRange={true}
                      monthsShown={2}
                      startDate={startdate}
                      endDate={enddate}
                      onChange={(update) => {
                        setStartdate(update[0]);
                        setEnddate(update[1]);
                        setDatelable("Custom Range");
                      }}
                      dateFormat="yyyy-MM-dd"
                      ref={datePickerRef}
                      autoComplete="none"
                    />
                  </div>
                  <button
                    className={Permission?.Add ? "com-btn" : "d-none"}
                    disabled={isRunning}
                    onClick={() => {
                      getlowstockplanning();
                    }}
                  >
                    {t("Run")}
                  </button>
                </div>
              </div>

              <div className="main-body-top-status-bar second-row-flexbox">
                <Select
                  className="limit-select short"
                  options={selectOptions}
                  value={{ label: limit, value: limit }}
                  onChange={(e) => {
                    setLimit(e.value);
                    getlimit(e.value);
                  }}
                />

                <div className="search-container-expandable" ref={inputRef}>
                  {isInputVisible ? (
                    <div className="wrap-expandable-input-field">
                      <button
                        onClick={(e) => filterbyname(filtername)}
                        className="main-body-top-status-bar-filter-search"
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.9269 14.04L17.4 17.4M16.28 8.43998C16.28 12.7699 12.7699 16.28 8.44001 16.28C4.11009 16.28 0.600006 12.7699 0.600006 8.43998C0.600006 4.11006 4.11009 0.599976 8.44001 0.599976C12.7699 0.599976 16.28 4.11006 16.28 8.43998Z"
                            stroke="#A4A4A4"
                            strokeLinecap="round"
                          />
                        </svg>
                      </button>

                      <input
                        type="text"
                        value={filtername}
                        className="main-body-top-status-bar-filter-input"
                        placeholder="TF No./StockID/SKU/Metal/Stone"
                        onKeyPress={(e) =>
                          e.key === "Enter" && filterbyname(e.target.value)
                        }
                        onChange={(e) => setFiltername(e.target.value)}
                      />
                      {filtername ? (
                        <svg
                          onClick={(e) => {
                            setFiltername("");
                            filterbyname("");
                          }}
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13 13L7 7M7 7L1 1M7 7L13 1M7 7L1 13"
                            stroke="#767676"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    <button
                      className="search-icon"
                      onClick={() => setIsInputVisible(true)}
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.9269 14.04L17.4 17.4M16.28 8.43998C16.28 12.7699 12.7699 16.28 8.44001 16.28C4.11009 16.28 0.600006 12.7699 0.600006 8.43998C0.600006 4.11006 4.11009 0.599976 8.44001 0.599976C12.7699 0.599976 16.28 4.11006 16.28 8.43998Z"
                          stroke="#A4A4A4"
                          strokeLinecap="round"
                        />
                      </svg>
                    </button>
                  )}
                </div>

                {/* <div className="main-body-top-status-bar-filter">
                  <input
                    type="text"
                    value={filtername}
                    className="main-body-top-status-bar-filter-input"
                    placeholder="TF No./StockID/SKU/Metal/Stone"
                    onKeyPress={(e) =>
                      e.key === "Enter" && filterbyname(e.target.value)
                    }
                    onChange={(e) => setFiltername(e.target.value)}
                  />
                  {filtername ? (
                    <img
                      className="main-body-top-status-bar-filter-clear"
                      src={base_assets + "images/icons/False.png"}
                      onClick={(e) => {
                        setFiltername("");
                        filterbyname("");
                      }}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                  <button
                    onClick={(e) => filterbyname(filtername)}
                    className="main-body-top-status-bar-filter-search"
                  >
                    <i className="fa fa-search" aria-hidden="true" />
                  </button>
                </div> */}

                <div className="main-body-top-status-bar-multi-date-picker">
                  <NewDateRange setDatefilter={setDatefilter} />
                  <div className="main-body-top-status-bar-print-export-dropdown btn dropdown">
                    <button
                      className="btn dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      aria-expanded={isOpen ? "true" : "false"}
                      // data-bs-toggle='dropdown'
                      onClick={toggleDropdown}
                    >
                      <svg
                        width="25"
                        height="20"
                        viewBox="0 0 25 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.5 4.16671C13.5 3.70647 13.0523 3.33337 12.5 3.33337C11.9477 3.33337 11.5 3.70647 11.5 4.16671C11.5 4.62694 11.9477 5.00004 12.5 5.00004C13.0523 5.00004 13.5 4.62694 13.5 4.16671Z"
                          fill="#A4A4A4"
                          stroke="#A4A4A4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M13.5 9.99996C13.5 9.53971 13.0523 9.16663 12.5 9.16663C11.9477 9.16663 11.5 9.53971 11.5 9.99996C11.5 10.4602 11.9477 10.8333 12.5 10.8333C13.0523 10.8333 13.5 10.4602 13.5 9.99996Z"
                          fill="#A4A4A4"
                          stroke="#A4A4A4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M13.5 15.8333C13.5 15.3731 13.0523 15 12.5 15C11.9477 15 11.5 15.3731 11.5 15.8333C11.5 16.2936 11.9477 16.6667 12.5 16.6667C13.0523 16.6667 13.5 16.2936 13.5 15.8333Z"
                          fill="#A4A4A4"
                          stroke="#A4A4A4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                    <ul
                      ref={secondRowOption}
                      className={`lsp-drop-down dropdown-menu ${isOpen ? "show" : ""
                        }`}
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li
                        className={
                          Permission?.Print
                            ? "dropdown-item print-dropdown-item"
                            : "d-none"
                        }
                        onClick={() => grtprintlowstock()}
                      >
                        <div className="dropdown-item-img">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_14421_72739)">
                              <path
                                d="M15.625 14.1667H16.6667C17.1269 14.1667 17.5 13.7936 17.5 13.3333V6.66667C17.5 6.20644 17.1269 5.83334 16.6667 5.83334H3.33333C2.8731 5.83334 2.5 6.20644 2.5 6.66667V13.3333C2.5 13.7936 2.8731 14.1667 3.33333 14.1667H4.375"
                                stroke="#A4A4A4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M5 10C5 9.53975 5.3731 9.16666 5.83333 9.16666H14.1667C14.6269 9.16666 15 9.53975 15 10V16.6667C15 17.1269 14.6269 17.5 14.1667 17.5H5.83333C5.3731 17.5 5 17.1269 5 16.6667V10Z"
                                stroke="#A4A4A4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M5 3.33333C5 2.8731 5.3731 2.5 5.83333 2.5H14.1667C14.6269 2.5 15 2.8731 15 3.33333V5.83333H5V3.33333Z"
                                stroke="#A4A4A4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M7.08331 11.25H12.9166"
                                stroke="#A4A4A4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M7.08331 15.4167H12.9166"
                                stroke="#A4A4A4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M7.08331 13.3333H12.9166"
                                stroke="#A4A4A4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_14421_72739">
                                <rect width="20" height="20" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <span>{t("Print")}</span>
                      </li>
                      <li
                        className="dropdown-item"
                        onClick={(e) => {
                          downloadexclsheet(e.target.value);
                        }}
                      >
                        <div className="dropdown-item-img">
                          <svg
                            width="16"
                            height="20"
                            viewBox="0 0 16 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0.5 19.1667H15.5V5.59083L10.7417 0.833328H0.5V19.1667ZM10.5 1.66666H10.6667L14.6667 5.66666V5.83333H10.5V1.66666ZM1.33333 1.66666H9.66667V6.66666H14.6667V18.3333H1.33333V1.66666ZM11.2425 8.33333L8.515 12.0833L11.2425 15.8333H10.2125L8 12.7917L5.7875 15.8333H4.75833L7.48583 12.0833L4.7575 8.33333H5.7875L8 11.375L10.2125 8.33333H11.2425Z"
                              fill="#A4A4A4"
                            />
                          </svg>
                        </div>
                        <span>{t("Export excel")}</span>
                      </li>
                      <li
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#newSocialModal"
                        onClick={() => getsharelowstock()}
                      >
                        <div className="dropdown-item-img">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.49998 10C7.49998 11.1506 6.56724 12.0833 5.41665 12.0833C4.26605 12.0833 3.33331 11.1506 3.33331 10C3.33331 8.84942 4.26605 7.91667 5.41665 7.91667C6.56724 7.91667 7.49998 8.84942 7.49998 10Z"
                              stroke="#A4A4A4"
                            />
                            <path
                              d="M11.6667 5.41667L7.5 8.33334"
                              stroke="#A4A4A4"
                              strokeLinecap="round"
                            />
                            <path
                              d="M11.6667 14.5833L7.5 11.6667"
                              stroke="#A4A4A4"
                              strokeLinecap="round"
                            />
                            <path
                              d="M15.8334 15.4167C15.8334 16.5672 14.9006 17.5 13.75 17.5C12.5994 17.5 11.6667 16.5672 11.6667 15.4167C11.6667 14.2661 12.5994 13.3333 13.75 13.3333C14.9006 13.3333 15.8334 14.2661 15.8334 15.4167Z"
                              stroke="#A4A4A4"
                            />
                            <path
                              d="M15.8334 4.58333C15.8334 5.73392 14.9006 6.66667 13.75 6.66667C12.5994 6.66667 11.6667 5.73392 11.6667 4.58333C11.6667 3.43274 12.5994 2.5 13.75 2.5C14.9006 2.5 15.8334 3.43274 15.8334 4.58333Z"
                              stroke="#A4A4A4"
                            />
                          </svg>
                        </div>
                        <span>{t("Share")}</span>
                      </li>
                      <li
                        className="dropdown-item dropdown-submenu"
                        // data-bs-toggle="modal"
                        // data-bs-target="#columnModal"
                        onClick={() => {
                          setShowEditColumns(true);
                        }}

                        ref={closeEditColumns}
                      >
                        {showEditColumns && <EditColumnSubmenu
                          tablehead={inventorylowstockplanlisthead}
                          tblName={"Low_stock_planning_tbl"}
                          setnewcolumndata={setnewcolumndata}
                          calldatatable={getlowstocklist}
                        ></EditColumnSubmenu>}
                        <div className="dropdown-item-img ">
                          <svg
                            width="24"
                            height="20"
                            viewBox="0 0 24 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M2.5 6V4C2.5 3.46957 2.67559 2.96086 2.98816 2.58579C3.30072 2.21071 3.72464 2 4.16667 2H15.8333C16.2754 2 16.6993 2.21071 17.0118 2.58579C17.3244 2.96086 17.5 3.46957 17.5 4V6M2.5 6V12M2.5 6H7.5M17.5 6V12M17.5 6H7.5M2.5 12V16C2.5 16.5304 2.67559 17.0391 2.98816 17.4142C3.30072 17.7893 3.72464 18 4.16667 18H7.5M2.5 12H7.5M7.5 6V12M17.5 12V16C17.5 16.5304 17.3244 17.0391 17.0118 17.4142C16.6993 17.7893 16.2754 18 15.8333 18H7.5M17.5 12H7.5M7.5 18V12M12.5 6V18"
                              stroke="#A4A4A4"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <rect
                              x="14"
                              y="8"
                              width="10"
                              height="10"
                              rx="5"
                              fill="white"
                            />
                            <path
                              d="M20.1132 10.8179L16.3251 14.606L16.2557 15.8538L17.5036 15.7845L21.2917 11.9964M20.1132 10.8179L20.6752 10.2559C21.0006 9.93048 21.5282 9.93048 21.8537 10.2559C22.1791 10.5814 22.1791 11.109 21.8537 11.4344L21.2917 11.9964M20.1132 10.8179L21.2917 11.9964"
                              stroke="#A4A4A4"
                              strokeWidth="0.75"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <span>{t("Edit Columns")}</span>
                        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1L6 6L1 11" stroke="#A4A4A4" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>

                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="main-body-main-table-wrap">
                <div className="low-stock-container-table-heading"
                  style={{ display: showCreatePoBtn ? "flex" : "none" }}
                >


                  <div className="low-stock-text">
                    <span>{selecteditem?.length} {t("Low Stock Planning Selected")}</span>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11 11L6 6M6 6L1 1M6 6L11 1M6 6L1 11" stroke="#A4A4A4" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>

                  </div>
                  <img src={IconReplenishment} alt="dots" />
                  <Link className="create-order-btn"
                    state={{
                      lowStockID: selecteditem,
                      hidelocationid: lowstocklist?.[0]?.location_ids?.[0],
                      hidesupplierid: lowstocklist?.[0]?.supplier_id,
                    }}
                    to={"/app/inventory/createpoReplenishOrder"}
                  >
                    Create Purchase Order
                  </Link>
                </div>
                <table
                  id="low_stock_table"
                  className="common-table first-row-gray w-100"
                >
                  <Tablehead
                    tablehead={inventorylowstockplanlisthead}
                    tblname={"Low_stock_planning_tbl"}
                    setfilterby={setfilterby}
                    setShowoption={setSelectAllStatus}
                  />
                  <tbody>
                    <>
                      {lowstocklist.length
                        ? lowstocklist?.map((result, key) => {
                          return (
                            <tr key={key}>
                              <td className="">
                                <div className="com-check">
                                  <input
                                    id={result?._id}
                                    className="lowstockHead"
                                    checked={selecteditem.includes(
                                      result?._id
                                    )}
                                    onChange={(e) =>
                                      selectedproduct(
                                        e.target.checked,
                                        result?._id
                                      )
                                    }
                                    type="checkbox"
                                  />
                                  <label
                                    htmlFor={result?._id}
                                    className="com-check-label"
                                  />
                                </div>
                              </td>
                              <td>{result?.date ? result?.date : "0"}</td>
                              <td>{result?.ls_no ? result?.ls_no : "0"}</td>
                              <td>{result?.StNo ? result?.StNo : "0"}</td>
                              <td>
                                <div className="tooltip-area-up">
                                  <div className="truncate-text-subtable">
                                    {result?.supplier_name
                                      ? result?.supplier_name
                                      : "0"}
                                  </div>
                                  {result?.supplier_name && <span className="tooltip-area-up-text text-white">{result?.supplier_name}</span>}
                                </div>
                              </td>
                              <td className="low-stock-col">
                                {result?.stores ? result?.stores : "0"}
                              </td>
                              <td>{result?.type ? result?.type : "0"}</td>
                              <td>
                                {result?.user
                                  ? result?.user
                                  : "-"}
                              </td>
                              <td>
                                {result?.SKUcount ? result?.SKUcount : "0"}
                              </td>
                              <td className="light-blue-text">
                                {result?.stock ? result?.stock : "0"}
                              </td>
                              <td className="danger-text">
                                {result?.sales_order
                                  ? result?.sales_order
                                  : "0"}
                              </td>
                              <td className="main-green-text">
                                {result?.available ? result?.available : "0"}
                              </td>
                              <td className="yellow-text">
                                {result?.reorderpoint
                                  ? result?.reorderpoint
                                  : "0"}
                              </td>
                              <td className="status-green-text">
                                {result?.reorderquantity
                                  ? result?.reorderquantity
                                  : "0"}
                              </td>
                              <td className='lsp-table-actions'>
                                <span className="social-modal-table-action">
                                  <svg
                                    className="share-icon-lsp-table"
                                    data-bs-toggle="modal"
                                    data-bs-target="#newSocialModal"
                                    onClick={() => getsharelowstock()}
                                    width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.50016 10C7.50016 11.1506 6.56742 12.0834 5.41683 12.0834C4.26624 12.0834 3.3335 11.1506 3.3335 10C3.3335 8.84944 4.26624 7.91669 5.41683 7.91669C6.56742 7.91669 7.50016 8.84944 7.50016 10Z" stroke="#A4A4A4" /> <path d="M11.6667 5.41669L7.5 8.33335" stroke="#A4A4A4" strokeLinecap="round" /> <path d="M11.6667 14.5834L7.5 11.6667" stroke="#A4A4A4" strokeLinecap="round" /> <path d="M15.8332 15.4166C15.8332 16.5672 14.9004 17.5 13.7498 17.5C12.5993 17.5 11.6665 16.5672 11.6665 15.4166C11.6665 14.2661 12.5993 13.3333 13.7498 13.3333C14.9004 13.3333 15.8332 14.2661 15.8332 15.4166Z" stroke="#A4A4A4" /> <path d="M15.8332 4.58333C15.8332 5.73392 14.9004 6.66667 13.7498 6.66667C12.5993 6.66667 11.6665 5.73392 11.6665 4.58333C11.6665 3.43274 12.5993 2.5 13.7498 2.5C14.9004 2.5 15.8332 3.43274 15.8332 4.58333Z" stroke="#A4A4A4" /> </svg>

                                </span>
                                <span className="parent-action-menu">
                                  
                                    <svg
                                      className="share-icon-lsp-table"
                                      onClick={() => handleOpenPDF(result?._id)}
                                      width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M4.1649 7.5V0.833334H16.25L19.1667 3.75V19.1667H3.33333M15 0.833334V5H19.1667M13.75 15.8333V10H17.0833M13.75 12.9167H16.25M2.5 10H2.70833H3.75C5.41667 10 5.625 11.0417 5.625 11.6667C5.625 12.2917 5.41667 13.3333 3.75 13.3333H2.70833V15H2.5V10ZM7.91667 15V10C7.91667 10 8.70614 10 9.33772 10C10.2851 10 11.25 10.4167 11.25 12.5C11.25 14.5833 10.2851 15 9.33772 15C8.70614 15 7.91667 15 7.91667 15Z" stroke="#A4A4A4" />
                                    </svg> 
                                </span>
                                <span className="parent-action-menu">
                                  {(result?.xls) ?
                                    <svg
                                      className="share-icon-lsp-table"
                                      onClick={() => downloadFilesXlxsAndPDF(result?.xls)}
                                      width="15" height="15" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M0.5 19.1667H15.5V5.59083L10.7417 0.833332H0.5V19.1667ZM10.5 1.66667H10.6667L14.6667 5.66667V5.83333H10.5V1.66667ZM1.33333 1.66667H9.66667V6.66667H14.6667V18.3333H1.33333V1.66667ZM11.2425 8.33333L8.515 12.0833L11.2425 15.8333H10.2125L8 12.7917L5.7875 15.8333H4.75833L7.48583 12.0833L4.7575 8.33333H5.7875L8 11.375L10.2125 8.33333H11.2425Z" fill="#A4A4A4" />
                                    </svg> : ""}
                                </span>
                              </td>
                            </tr>
                          );
                        })
                        : ""}
                    </>
                  </tbody>
                </table>
              </div>
            </div>
            {lowstocklist.length > 0 ? (
              <NewPaginationBlock
                total={totalPages}
                current={currentPage}
                pagination={(crPage) => handlePaginations(crPage)}
              />
            ) : (
              ""
            )}
          </div>
        </div>
        <SocialModal shareUrl={socialurl} shareloader={shareloader} />
      </div>
      <NewSocialModal shareUrl={socialurl} shareloader={shareloader} />
    </React.Fragment>
  );
};
export default LowStockPlanning;
